export default "__VITE_ASSET__dac53d43__"